import React from "react";
import clg from "./log";
import { Helmet } from "react-helmet";
//import __ from "./__";

//og, article-el keződök <meta property=[] content=[]>
//többi <meta name=[] content=[]>

const MetaTags = ({ meta = null, title = null, urlPrefix = null }) => {

    const getFormattedProperties = () => {
        /* let data = [
          { property: "test-1", content: "value-a" },
          { property: "test-2", content: "value-b" },
          { name: "test-3", content: "value-c" },
        ]; */


        const formatContentIfNeccesary = ( content, key ) => {
            const _key = key.toLowerCase(); // !!!!!!!!!!!!!!


            if( content.includes("{url}") ) {
                return content.replace("{url}", urlPrefix).replace("/:slug","");
            }
            
            switch (_key) {
                case "og:url":
                case "dc:identifier":
                    //https://teszt.soforallasok.com/{jobs}/talsza-trans-kft/ce-kat-sofor-allas -> https://teszt.soforallasok.com/[router.job_listings]/talsza-trans-kft/ce-kat-sofor-allas
                    //return content.replace( "{jobs}", __("routes.job_listings").replace("/","") );
                    return content/* .replace( "{jobs}", __("routes.job_listings").replace("/","") ); */
                default:
                    return content;
            }
        }

        let data = [];

        const problematicItems = [ "article:", "og:" ];

        const tagTypeToAttrType = {
            "article:" : "property",
            "og:" : "property",
            "default" : "name"
        }

        Object.entries(meta).forEach(([key, value]) => {
            //property vagy name attr szükséges?
            if( key.includes(":") ) {
                const postfix = key.split(":")[0] + ":";
                if( problematicItems.includes(postfix) ) {
                    if( value !== null ) {
                        if( value.length > 0 ) {
                            data.push( { [tagTypeToAttrType[postfix]] : key, content : formatContentIfNeccesary(value, key) } )
                        }
                    }
                } else {
                    //Ha nem "kiemelt figyelmet igénylő elem (nem szerepel a problematicItems tömbben)"
                    if( value !== null ) {
                        if(  !Array.isArray(value) ) {
                            if( value.length > 0 ) {
                                data.push( { [tagTypeToAttrType["default"]] : key, content : formatContentIfNeccesary(value, key) } )
                            }
                        } else {
                            for( let index in value ) {
                                const curr = value[index];
                                if( curr.length > 0 ) {
                                    data.push( { [tagTypeToAttrType["default"]] : key, content : formatContentIfNeccesary(curr, key) } )
                                }
                            }
                        }
                    }
                }
            } else {
                if( value !== null ) {
                    if( value.length ) {
                        data.push( { [tagTypeToAttrType["default"]] : key, content : formatContentIfNeccesary(value, key) } )
                    }
                } 
            }
        });

        clg("Metadata: ", data);

        return data;
      }

    return (
        <Helmet>
            {
                title && (
                    <title>{title}</title>
                )
            }
            {
                meta && (
                    getFormattedProperties().map((object,index) => <meta {...object} key={index} />)
                )
            }
        </Helmet>
    )
}

export default MetaTags;
